import { LassoSelectionStates } from "types/lasso";

import { getLineChartFilteredItems } from "./utils";

export function getCumTimeList({ params, series }: Partial<LassoSelectionStates>) {
  const list = getLineChartFilteredItems(params, series);
  return list;
}
